/**
 * Legacy sync service - NO LONGER USED
 * The application now uses IDB through expense-repository.impl.ts
 * This file exists only to prevent import errors in unused Effect-based code
 */

import * as Effect from 'effect/Effect';
import * as Context from 'effect/Context';
import * as Layer from 'effect/Layer';

export interface SyncStatus {
  isRunning: boolean;
  lastSyncTime: Date | null;
  pendingOperations: number;
  failedOperations: number;
  isOnline: boolean;
}

export interface SyncResult {
  successful: number;
  failed: number;
  pending: number;
  conflicts: number;
}

export interface SyncService {
  getStatus: Effect.Effect<SyncStatus, never>;
  syncNow: Effect.Effect<SyncResult, never>;
  processQueue: Effect.Effect<SyncResult, never>;
}

export const SyncService = Context.GenericTag<SyncService>('SyncService');

// Stub implementation
const stubImplementation: SyncService = {
  getStatus: Effect.succeed({
    isRunning: false,
    lastSyncTime: null,
    pendingOperations: 0,
    failedOperations: 0,
    isOnline: true
  }),
  syncNow: Effect.succeed({
    successful: 0,
    failed: 0,
    pending: 0,
    conflicts: 0
  }),
  processQueue: Effect.succeed({
    successful: 0,
    failed: 0,
    pending: 0,
    conflicts: 0
  })
};

export const SyncLayer = Layer.succeed(SyncService, stubImplementation);